import { green } from "../colors/index.js";
const successColor = (mode)=>'light' === mode ? {
        main: green["500"],
        highContrast: green["700"],
        lowContrast: green["100"]
    } : {
        main: green["400"],
        highContrast: green["100"],
        lowContrast: green["800"]
    };
export { successColor };

//# sourceMappingURL=success.js.map